<div class="main-container-finance">
  <div class="header-section">
    <div class="header-text">
      <h1>Finance Dashboard</h1>
      <p class="header-sub">D&amp;T India financial workflows &amp; reports</p>
    </div>
  </div>

  <div class="cards-grid">
    <mat-card
      *ngFor="let tile of tiles"
      class="finance-tile"
      [class.clickable]="!tile.comingSoon"
      [class.coming-soon]="tile.comingSoon"
      (click)="onTileClick(tile)"
    >
      <div class="tile-accent"></div>

      <div class="tile-header">
        <div class="tile-icon-wrap">
          <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
        </div>
        <span class="tile-title">{{ tile.title }}</span>
        <mat-icon *ngIf="tile.comingSoon" class="lock-icon" matTooltip="Coming soon">lock_clock</mat-icon>
      </div>

      <div *ngIf="tile.comingSoon" class="coming-soon-body">
        <mat-icon class="watermark-icon">{{ tile.icon }}</mat-icon>
        <p class="coming-sub">Available soon</p>
      </div>

      <div *ngIf="!tile.comingSoon" class="active-tile-body">
        <table class="preview-table">
          <thead>
            <tr>
              <th>Timelines &amp; Last Dates</th>
              <th>Action Items</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of previewRows" [class.highlight]="row.highlight">
              <td>{{ row.dateRange }}</td>
              <td>{{ row.action }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="!tile.comingSoon" class="tile-footer">
        <button type="button" class="open-btn" (click)="onTileClick(tile); $event.stopPropagation()">
          View calendar
          <mat-icon class="cta-arrow">arrow_forward</mat-icon>
        </button>
      </div>
    </mat-card>
  </div>
</div>
